/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import {
    object,  string, arrayOf, array, shape, number,
} from 'prop-types';
import { useUIDSeed } from 'react-uid';
import LazyLoad from 'react-lazyload';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

const ProductPlaImageUIMobile = ({
    classes,
    name,
    path,
    additionalImages,
    productName,
    deliveryMessage,
    productSkus,
}) => {
    const seed = useUIDSeed();
    const showPriceRanges = () => {
        const retailArr = [];
        const saleArr = [];
        if (productSkus) {
            productSkus.forEach((sku) => {
                retailArr.push(sku.prices[0]?.value);
                saleArr.push(sku.prices[1]?.value);
            });
            retailArr.sort((a, b) => (a - b));
            saleArr.sort((a, b) => (a - b));
        }
        return (
            <>
                <div className={classes.retail}>${retailArr?.[0]} - ${retailArr?.[retailArr.length - 1]}</div>
                <div className={classes.sale}>${saleArr?.[0]} - ${saleArr?.[saleArr.length - 1]}</div>
            </>
        );
    };

    return (
        <div className={classes.container}>
            <Paper className={classes.img}>
                <div className={classes.sliderContainer}>
                    <img className={classes.plaSlide} alt={productName} src={`${path}${name}x.jpg`} />
                    {additionalImages?.map((img) => (
                        <LazyLoad key={seed(img)}>
                            <img className={classes.slide} alt={productName} src={`${path}${img}x.jpg`} />
                        </LazyLoad>
                    ))}
                </div>
            </Paper>
            <Grid className={classes.plaSummaryContainer}>
                <h1 className={classes.plaProdName}>{productName}</h1>
                {showPriceRanges()}
                <div className={classes.plaDelivery}>{deliveryMessage}</div>
            </Grid>
        </div>
    );
};

ProductPlaImageUIMobile.propTypes = {
    classes: object.isRequired,
    name: string.isRequired,
    path: string.isRequired,
    additionalImages: array.isRequired,
    productName: string.isRequired,
    deliveryMessage: string.isRequired,
    productSkus: arrayOf(shape({
        prices: arrayOf(shape({
            value: number.isRequired,
        })),
    })).isRequired,
};

export default ProductPlaImageUIMobile;
